import { themeMaterial } from "ag-grid-community"
/*
  reference for class name & theme builder
  1. theme builder: https://www.ag-grid.com/archive/32.3.3/theme-builder/
  2. theming api: https://www.ag-grid.com/archive/32.3.3/react-data-grid/theming-api/
*/
const defaultParams = {
  dataFontSize: 12,
  fontSize: 12,
  headerFontSize: 12,
  rowHeight: 30,
  headerHeight: 30,
  borderRadius: 0,
  wrapperBorderRadius: 0,
  cellHorizontalPadding: 23,
  headerFontWeight: 600,
};

const modernLight = themeMaterial.withParams({
  accentColor: 'rgba(12, 107, 185, 1)',
  backgroundColor: '#ffffff',
  cellTextColor: 'rgba(16, 20, 29, .65)',
  headerBackgroundColor: '#f1f2f4',
  headerTextColor: 'rgba(16,20,29,.9)',
  selectedRowBackgroundColor: "#BAD0E2",
  rowHoverColor: "rgba(12, 107, 185, 0.08)",
  headerCellHoverBackgroundColor: 'rgba(16, 20, 29, 0.09)',
  modalOverlayBackgroundColor: '#ffffff',
  ...defaultParams
});

const modernDark = themeMaterial.withParams({
  accentColor: 'rgba(12, 107, 185, 1)',
  backgroundColor: '#171D2B',
  cellTextColor: 'hsla(0, 0%, 100%, .7)',
  headerBackgroundColor: '#0d1017',
  headerTextColor: '#fff',
  selectedRowBackgroundColor: "#274A6C",
  rowHoverColor: "rgba(71, 169, 246, 0.08)",
  headerCellHoverBackgroundColor: 'rgba(255, 255, 255, 0.12)',
  modalOverlayBackgroundColor: '#171D2B',
  ...defaultParams
});

const themes = { modernLight, modernDark };
export default themes;
